import React from "react";
import PropTypes from "prop-types";
import PriceDisplay from "../../../../../../../containers/PriceDisplay";
import styles from "./styles.less";

const AddonItem = ({
  id,
  name,
  amount,
  price,
  titles,
  onAddonRemove,
  currency,
  currencyCode
}) => {
  const onRemove = () => {
    onAddonRemove && onAddonRemove(id);
  };

  const priceToDisplay = (
    <PriceDisplay
      price={price}
      currentCurrencyCode={currencyCode}
      fallBackCurrencySymbol={currency}
    >
      {convertedPrice => `- ${name} ( ${amount}x${convertedPrice} )`}
    </PriceDisplay>
  );

  return (
    <div className={styles.addon}>
      <div className={styles.details}>{priceToDisplay}</div>
      <div
        className={styles.removeBtn}
        onClick={onRemove}
        onKeyDown={onRemove}
        role="button"
        tabIndex="0"
      >
        {titles.Remove}
      </div>
    </div>
  );
};

AddonItem.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
  amount: PropTypes.number,
  price: PropTypes.number,
  titles: PropTypes.object,
  currency: PropTypes.string,
  currencyCode: PropTypes.string,
  onAddonRemove: PropTypes.func
};

export default AddonItem;



// WEBPACK FOOTER //
// ./src/components/Cart/Rooms/Room/RoomBody/AddonsList/AddonItem/AddonItem.js